import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import { ConfigProvider } from './services/ConfigProvider';
import { ErrorBoundary } from './services/tracer';
import { redirectLegacyUserToRollout } from './utils/rolloutRedirect';

const redirectedToRollout = redirectLegacyUserToRollout();

if (!redirectedToRollout) {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <ConfigProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ConfigProvider>
    </React.StrictMode>,
  );
}
